import {useContext, useEffect} from 'react'
import {ProfitabilityContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {PROFITABILITY_COLUMNS, PROFITABILITY_COLUMNS_WithShorting} from '../../utils'
import ProfitabilityRow from './CustomersTableRow'
import {parseCustomerRow} from '../../parsings'
import {formatPrice} from '../../../../utils/common'
import CustomerTableHeader from '../header/CustomerTableHeader'

const CustomersTable = () => {
  const {profitabilityData, isLoading, onSortingChange, filters, isFullView} =
    useContext(ProfitabilityContext)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [isFullView])

  return (
    <div className={isFullView ? 'mt=15' : 'card border'}>
      <div className={isFullView ? '' : 'card-body p-7'}>
        <CustomerTableHeader />
        <div className='sticky-table-wrapper'>
          <div className='table-responsive-wrapper'>
            <div className='table-responsive'>
              <DynamicTable
                data={isFullView ? profitabilityData : profitabilityData?.slice(0, 5)}
                sortableColumns={
                  isFullView ? PROFITABILITY_COLUMNS_WithShorting : PROFITABILITY_COLUMNS
                }
                loading={isLoading}
                noDataMessage='No profitability data found'
                onSortingChange={onSortingChange}
                tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2 mb-0'
                TableRow={ProfitabilityRow}
                tableHeaderClass='sticky-table-header'
                rowParsingFunction={parseCustomerRow}
                filters={filters}
                tableFooter={({columnTotals}: any) =>
                  !isFullView ? (
                    <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
                      <tr>
                        <td colSpan={3}>TOTAL</td>
                        <td>{columnTotals.total_orders}</td>
                        <td>{formatPrice(columnTotals.total_cost, false)}</td>
                        <td>{formatPrice(columnTotals.total_revenue, false)}</td>
                        <td></td>
                        <td>{formatPrice(columnTotals.total_profit, false)}</td>
                      </tr>
                    </tfoot>
                  ) : null
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomersTable
